import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { useSeller } from "../../../context/seller";
import { FormEvent, useEffect, useState } from "react";
import ToursService from "../../../services/tours.service";
import Select from "../../common/Select";
import { useGlobal } from "../../../context/global";
import Calendar from "../../common/Calendar";
import SellerService from "../../../services/seller.service";
import { Group } from "../../../types/common.types";

export default function AddReservationGroup() {
    const { setMessage } = useGlobal()
    const { setNewGroup, setNewGroupReservationData, summary, setIsSummaryModalOpen, setIsTicketPaymentGroupModalOpen } = useSeller()

    const [tours, setTours] = useState([])
    const [tourId, setTourId] = useState<string>('')
    const [date, setDate] = useState<Date | undefined>()

    useEffect(() => {
        async function getTours() {
            try {
                if (tours.length) return
                const response = await ToursService.list()
                const options = response.data.map((tour: any) => ({
                    value: tour.id,
                    name: tour.id
                }))
                setTours(options)
            } catch (error) {
                setMessage({type: 'error', content: 'Error loading tours'})
            }
        }
        getTours()
    }, [tours, setMessage])

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (!tourId || !date) {
            setTimeout(() => setMessage(undefined), 5000)
            setMessage({type: 'error', content: 'Complete all fields'})
            return
        }
        try {
            setNewGroupReservationData(prevData => ({...prevData, tour_id: tourId, reservation_date: date}))
            setIsTicketPaymentGroupModalOpen(true)
            setMessage({type: 'success', content: 'Group reservation created'})
        } catch (error) {
            setMessage({type: 'error', content: 'Complete all fields'})
            
        } finally {
            setTimeout(() => setMessage(undefined), 5000)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Add reservation data</h1>
            <Select
            options={tours}
            label="Tour"
            defaultNull
            onChange={e => setTourId(e.target.value)}
            />
            <Calendar
            containerStyle={{width: '100%', margin: '20px 0'}}
            selectedDay={date}
            setSelectedDay={setDate}
            />
            <div className="actions">
                <button type="submit">Continue</button>
                {
                    summary && summary.length > 0 &&
                    <button
                    type="button"
                    onClick={() => setIsSummaryModalOpen(true)}
                    >
                        View summary
                    </button>
                }
            </div>
            <div className="close" title="close"
            onClick={() => setNewGroup([])}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}